import React from 'react'
import ProgressCircle from './ProgressCircle'

export default function LoadingProgress() {
    return (
        <div style={{
            textAlign: 'center',
            verticalAlign: 'center',
            height: '100vh',
            backgroundColor: '#FFF',
            marginTop: '45vh',
        }}>
            <ProgressCircle />
        </div>
    )
}
